import React, { Component } from 'react';
import { connect } from 'react-redux';
import Depth from './depth';
import TradingView from './tradingView';
import OHLC from './ohlc';
import Stats from './stats';

class Chart extends Component {
  render() {
    return (
      <div className='row'>
        <div className='col s12' style={{}}>
          <Stats/>
        </div>
        <div id='padding' className="col s12 boxShadow">
           <TradingView />
           <Depth/>
         </div>
      </div>
		)
  }
}


export default Chart;
